// extracted by mini-css-extract-plugin
module.exports = {"betaTag":"BetaTag_betaTag__sgoG8"};